import { render, staticRenderFns } from "./CompraPorPeriodo.vue?vue&type=template&id=4e26c027&"
import script from "./CompraPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./CompraPorPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports